import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginGuard } from './core/guards/auth/Login.guard';
import { RoleGuard } from './core/guards/auth/role.guard';
import { ManagementGuard } from './core/guards/auth/management.guard';
import { UserPremiumGuard } from './core/guards/auth/user-premium.guard';
import { UserGuard } from './core/guards/auth/user.guard';
import { AdminGuard } from './core/guards/admin.guard';
import { CourseGuard } from './core/guards/auth/course.guard';

import { ActivityManagementComponent } from './modules/activity-management/activity-management.component';
import { ConsultComponent } from './modules/activity-management/consult/consult.component';
import { ManageWorkshopComponent } from './modules/activity-management/workshop/manage-workshop/manage-workshop.component';
import { WorkshopComponent } from './modules/activity-management/workshop/workshop.component';
import { ActivityComponent } from './modules/activity/activity.component';
import { AllWorkshopComponent } from './modules/activity/workshop/all-workshop.component';
import { WorkshopDetailComponent } from './modules/activity/workshop/workshop-detail/workshop-detail.component';
import { AllNewsComponent } from './modules/all-news/all-news.component';
import { NewsComponent } from './modules/all-news/news/news.component';
import { ForgotPasswordComponent } from './modules/forgot-password/forgot-password.component';
import { HomeComponent } from './modules/home/home.component';
import { LoginComponent } from './modules/login/login.component';
import { ManageNewsComponent } from './modules/news-update-management/manage-news/manage-news.component';
import { NewsUpdateComponent } from './modules/news-update-management/news-update.component';
import { ProfileComponent } from './modules/profile/profile.component';
import { ChangePasswordComponent } from './modules/profile/change-password/change-password.component';
import { RegisterComponent } from './modules/register/register.component';
import { HistoryComponent } from './modules/user-management/history/history.component';
import { UserManagementComponent } from './modules/user-management/user-management.component';
import { AddConsultComponent } from './modules/activity-management/consult/manage-consult/add-consult/add-consult.component';
import { ManageConsultComponent } from './modules/activity-management/consult/manage-consult/manage-consult.component';
import { DuplicateConsultComponent } from './modules/activity-management/consult/manage-consult/duplicate-consult/duplicate-consult.component';
import { ConsultUserComponent } from './modules/activity/consult/consult-user.component';
import { AboutComponent } from './modules/about/about.component';
import { ELearningManagementComponent } from './modules/e-learning-management/e-learning-management.component';
import { ManageCourseComponent } from './modules/e-learning-management/manage-course/manage-course.component';
import { ELearningComponent } from './modules/e-learning/e-learning.component';
import { CourseComponent } from './modules/e-learning/course/course.component';
import { AssignmentComponent } from './modules/e-learning-management/assignment/assignment.component';
import { AssignmentManagementComponent } from './modules/e-learning-management/assignment-management/assignment-management.component';
import { ReviewManagementComponent } from './modules/e-learning-management/review-management/review-management.component';
import { UpgradePremiumComponent } from './modules/profile/upgrade-premium/upgrade-premium.component';
import { ArticalManagementComponent } from './modules/artical-management/artical-management.component';
import { ManageArticalComponent } from './modules/artical-management/manage-artical/manage-artical.component';
import { ArticalsComponent } from './modules/articals/articals.component';
import { ArticalComponent } from './modules/articals/artical/artical.component';
import { SkillTreeManagementComponent } from './modules/skill-tree-management/skill-tree-management.component';
import { ManageSkillTreeComponent } from './modules/skill-tree-management/manage-skill-tree/manage-skill-tree.component';
import { UserHistoryComponent } from './modules/user-history/user-history.component';
import { ChatManagementComponent } from './modules/e-learning-management/chat-management/chat-management.component';
import { SearchComponent } from './modules/search/search.component';
import { SkillTreeByCourseComponent } from './modules/skill-tree-by-course/skill-tree-by-course.component';
import { PrivacyPolicyComponent } from './modules/privacy-policy/privacy-policy.component';
import { ChangePasswordGuard } from './core/guards/auth/change-password.guard';
import { PaymentComponent } from './modules/payment/payment.component';
import { TransferComponent } from './modules/payment/transfer/transfer.component';
import { PaymentManagementComponent } from './modules/payment-management/payment-management.component';
import { PaymentDetailComponent } from './modules/payment-management/payment-detail/payment-detail.component';
import { PaymentVerifyComponent } from './modules/payment-management/payment-verify/payment-verify.component';
import { MeasureManagementComponent } from './modules/measure-management/measure-management.component';
import { ManageMeasureComponent } from './modules/measure-management/manage-measure/manage-measure.component';
import { MeasureComponent } from './modules/measure/measure.component';
import { MeasureManagementDetailComponent } from './modules/measure-management/measure-management-detail/measure-management-detail.component';
import { MeasureStartComponent } from './modules/measure/measure-start/measure-start.component';
import { MeasureDetailComponent } from './modules/measure/measure-detail/measure-detail.component';
import { ResearchComponent } from './modules/research/research.component';
import { ResearchMeasureComponent } from './modules/research/research-measure/research-measure.component';
import { ResearchScreenQuestionComponent } from './modules/research/research-screen-question/research-screen-question.component';
import { ResearchConsentComponent } from './modules/research/research-consent/research-consent.component';
import { ResearchDetailComponent } from './modules/research/research-detail/research-detail.component';
import { MeasureCheckViewGuard } from './core/guards/auth/measure-check-view.guard';
import { ResearchManagementComponent } from './modules/research-management/research-management.component';
import { ManageResearchComponent } from './modules/research-management/manage-research/manage-research.component';
import { ReportManagementComponent } from './modules/report-management/report-management.component';
import { ManageReportComponent } from './modules/report-management/manage-report/manage-report.component';
import { ReportTemplateComponent } from './modules/report-management/report-template/report-template.component';
import { TestReportComponent } from './modules/test-report/test-report.component';
import { ReportBoxchartComponent } from './shared/components/report-boxchart/report-boxchart.component';
import { ReportMatchingComponent } from './shared/components/report-matching/report-matching.component';
import { ReportProfileComponent } from './shared/components/report-profile/report-profile.component';
import { ReportSpiderComponent } from './shared/components/report-spider/report-spider.component';
import { ReportStandardComponent } from './shared/components/report-standard/report-standard.component';
import { DashboardAdminComponent } from './modules/dashboard-admin/dashboard-admin.component';
import { FinancialListComponent } from './modules/financial-list/financial-list.component';
import { FinancialCategoryComponent } from './modules/financial-list/financial-category/financial-category.component';
import { PaymentSuccessComponent } from './modules/payment/payment-success/payment-success.component';
import { NotificationComponent } from './modules/notification/notification.component';
import { PageNotFoundComponent } from './modules/page-not-found/page-not-found.component';
import { CreateReceiptInvoiceComponent } from './modules/accounting/create-receipt-from-invoice/create-receipt-from-invoice.component';
import { PaymentManagementGovermentComponent } from './modules/payment-management/payment-management-goverment/payment-management-goverment.component';
import { PaymentManagementCompanyComponent } from './modules/payment-management/payment-management-company/payment-management-company.component';
import { CreateInvoiceComponent } from './modules/accounting/create-invoice/create-invoice.component';
import { CreateQuotationComponent } from './modules/accounting/create-quotation/create-quotation.component';
import { CreatePersonalReceiptComponent } from './modules/accounting/create-personal-receipt/create-personal-receipt.component';
import { AccountingComponent } from './modules/accounting/accounting.component';
import { PrivateChatManagementComponent } from './modules/e-learning-management/private-chat-management/private-chat-management.component';
import { CoursePrivateChatGuard } from './core/guards/auth/course-private-chat.guard';
import { ELearningManagementTaComponent } from './modules/e-learning-management-ta/e-learning-management-ta.component';
import { TAGuard } from './core/guards/ta.guard';
import { ReportTopRankComponent } from './shared/components/report-top-rank/report-top-rank.component';
import { LearningCenterComponent } from './modules/learning-center/learning-center.component';
import { LearningCenterManagementComponent } from './modules/learning-center-management/learning-center-management.component';
import { ManageLearningCenterComponent } from './modules/learning-center-management/manage-learning-center/manage-learning-center.component';
import { LearningCenterDetailComponent } from './modules/learning-center/learning-center-detail/learning-center-detail.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [LoginGuard],
  },
  {
    path: 'register',
    component: RegisterComponent,
  },
  {
    path: 'forgotPassword',
    component: ForgotPasswordComponent,
  },
  {
    path: 'changePassword',
    component: ChangePasswordComponent,
    canActivate: [ChangePasswordGuard],
  },
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [RoleGuard],
  },
  {
    path: 'about',
    component: AboutComponent,
  },
  {
    path: 'upgrade-premium',
    component: UpgradePremiumComponent,
    canActivate: [UserPremiumGuard],
  },
  {
    path: 'news',
    children: [
      {
        path: '',
        component: AllNewsComponent,
      },
      {
        path: ':newsId',
        component: NewsComponent,
      },
    ],
  },
  {
    path: 'activity',
    children: [
      {
        path: '',
        component: ActivityComponent,
      },
      {
        path: 'workshop',
        children: [
          {
            path: '',
            component: AllWorkshopComponent,
          },
          {
            path: ':workshopId',
            component: WorkshopDetailComponent,
          },
        ],
      },
      {
        path: 'consult',
        children: [
          {
            path: '',
            component: ConsultUserComponent,
          },
        ],
      },
    ],
  },
  {
    path: 'e-learning',
    children: [
      {
        path: '',
        component: ELearningComponent,
      },
      {
        path: ':courseId',
        component: CourseComponent,
        canActivate: [CourseGuard],
      },
    ],
  },
  {
    path: 'skill-tree',
    component: SkillTreeByCourseComponent,
  },
  {
    path: 'article',
    children: [
      {
        path: '',
        component: ArticalsComponent,
      },
      {
        path: ':articalId',
        component: ArticalComponent,
      },
    ],
  },
  {
    path: 'news-management',
    canActivate: [ManagementGuard],
    children: [
      {
        path: '',
        component: NewsUpdateComponent,
      },
      {
        path: 'manage-news',
        component: ManageNewsComponent,
      },
    ],
  },
  {
    path: 'user-management',
    canActivate: [ManagementGuard],
    children: [
      {
        path: '',
        component: UserManagementComponent,
      },
      {
        path: ':type',
        component: HistoryComponent,
      },
    ],
  },
  {
    path: 'activity-management',
    canActivate: [ManagementGuard],
    children: [
      {
        path: '',
        component: ActivityManagementComponent,
      },
      {
        path: 'consult',
        children: [
          {
            path: '',
            component: ConsultComponent,
          },
          {
            path: 'manage-consult',
            component: ManageConsultComponent,
          },
          {
            path: 'add',
            component: AddConsultComponent,
          },
          {
            path: 'duplicate',
            component: DuplicateConsultComponent,
          },
        ],
      },
      {
        path: 'workshop',
        children: [
          {
            path: '',
            component: WorkshopComponent,
          },
          {
            path: ':isEdit',
            component: ManageWorkshopComponent,
          },
        ],
      },
    ],
  },
  {
    path: 'e-learning-management',
    canActivate: [ManagementGuard],
    children: [
      {
        path: '',
        component: ELearningManagementComponent,
      },
      {
        path: 'manage-course',
        component: ManageCourseComponent,
      },
      {
        path: 'assignment',
        component: AssignmentComponent,
      },
      {
        path: 'assignment-management',
        component: AssignmentManagementComponent,
      },
      {
        path: 'review-management',
        component: ReviewManagementComponent,
      },
      {
        path: 'chat-management',
        component: ChatManagementComponent,
      },
    ],
  },
  {
    path: 'e-learning-management/private-chat-management',
    canActivate: [CoursePrivateChatGuard],
    component: PrivateChatManagementComponent,
  },
  {
    path: 'e-learning-management-ta',
    canActivate: [TAGuard],
    component: ELearningManagementTaComponent,
  },
  {
    path: 'article-management',
    canActivate: [ManagementGuard],
    children: [
      {
        path: '',
        component: ArticalManagementComponent,
      },
      {
        path: 'manage-article',
        component: ManageArticalComponent,
      },
    ],
  },
  {
    path: 'skill-tree-management',
    canActivate: [ManagementGuard],
    children: [
      {
        path: '',
        component: SkillTreeManagementComponent,
      },
      {
        path: 'manage-skill-tree',
        component: ManageSkillTreeComponent,
      },
    ],
  },
  {
    path: 'user-history',
    component: UserHistoryComponent,
    // canActivate: [RoleGuard],
  },
  {
    path: 'privacy-policy',
    component: PrivacyPolicyComponent,
  },
  {
    path: 'search',
    component: SearchComponent,
  },
  {
    path: 'payment',
    // canActivate: [UserGuard],
    component: PaymentComponent,
  },
  {
    path: 'transfer',
    // canActivate: [UserGuard],
    component: TransferComponent,
  },
  {
    path: 'test-report',
    // canActivate: [UserGuard],
    component: TestReportComponent,
  },
  {
    path: 'payment-success',
    // canActivate: [UserGuard],
    component: PaymentSuccessComponent
  },
  {
    path: 'payment-management',
    canActivate: [AdminGuard],
    children: [
      {
        path: '',
        component: PaymentManagementComponent,
      },
      {
        path: 'payment-management-goverment',
        children: [
          {
            path: '',
            component: PaymentManagementGovermentComponent
          },
          {
            path: 'payment-detail',
            component: PaymentDetailComponent,
          },
          {
            path: 'payment-verify',
            component: PaymentVerifyComponent,
          },
        ]
      },
      {
        path: 'payment-management-company',
        children: [
          {
            path: '',
            component: PaymentManagementCompanyComponent
          },
        ]
      },
    ]
  },
  {
    path: 'measure-management',
    canActivate: [ManagementGuard],
    children: [
      {
        path: '',
        component: MeasureManagementComponent,
      },
      {
        path: 'manage-measure',
        component: ManageMeasureComponent,
      },
      {
        path: 'measure-managament-detail',
        component: MeasureManagementDetailComponent,
      },
    ],
  },
  {
    path: 'measure',
    children: [
      {
        path: '',
        component: MeasureComponent,
      },
      {
        path: 'measure-start',
        component: MeasureStartComponent,
      },
    ],
  },
  {
    path: 'measure/:link',
    canActivate: [MeasureCheckViewGuard],
    component: MeasureDetailComponent,
  },
  {
    path: 'research',
    children: [
      {
        path: '',
        component: ResearchComponent,
      },
      {
        path: 'research-consent',
        component: ResearchConsentComponent,
      },
      {
        path: 'research-screen-question',
        component: ResearchScreenQuestionComponent,
      },
      {
        path: 'research-detail',
        component: ResearchDetailComponent,
      },
      {
        path: 'research-measure',
        component: ResearchMeasureComponent,
      },
    ],
  },
  {
    path: 'research-management',
    canActivate: [ManagementGuard],
    children: [
      {
        path: '',
        component: ResearchManagementComponent,
      },
      {
        path: 'manage-research',
        component: ManageResearchComponent,
      },
    ],
  },
  {
    path: 'report-management',
    canActivate: [ManagementGuard],
    children: [
      {
        path: '',
        component: ReportManagementComponent,
      },
      {
        path: 'manage-report',
        component: ManageReportComponent,
      },
      {
        path: 'report-template',
        component: ReportTemplateComponent,
      },
    ],
  },
  {
    path: 'report-boxchart',
    component: ReportBoxchartComponent,
  },
  {
    path: 'report-matching',
    component: ReportMatchingComponent,
  },
  {
    path: 'report-profile',
    component: ReportProfileComponent,
  },
  {
    path: 'report-spider',
    component: ReportSpiderComponent,
  },
  {
    path: 'report-standard',
    component: ReportStandardComponent,
  },
  {
    path: 'report-top-rank',
    component: ReportTopRankComponent
  },
  {
    path: 'dashboard',
    component: DashboardAdminComponent,
  },
  {
    path: 'financial-list',
    // canActivate: [ManagementGuard],
    children: [
      {
        path: '',
        component: FinancialListComponent,
      },
      {
        path: ':category',
        component: FinancialCategoryComponent,
      },
    ],
  },
  {
    path: 'accounting',
    canActivate: [AdminGuard],
    children: [
      {
        path: '',
        component: AccountingComponent,
      },
      {
        path: 'create-receipt-from-invoice',
        component: CreateReceiptInvoiceComponent,
      },
      {
        path: 'create-invoice',
        component: CreateInvoiceComponent,
      },
      {
        path: 'create-quotation',
        component: CreateQuotationComponent,
      },
      {
        path: 'create-personal-receipt',
        component: CreatePersonalReceiptComponent,
      },
    ]
  },
  {
    path: 'notification',
    component: NotificationComponent,
    canActivate: [RoleGuard],
  },
  {
    path: 'learning-center',
    children: [
      {
        path: '',
        component: LearningCenterComponent,
      },
      {
        path: ':id',
        component: LearningCenterDetailComponent,
      },
    ]
  },
  {
    path: 'learning-center-management',
    children: [
      {
        path: '',
        component: LearningCenterManagementComponent,
      },
      {
        path: 'manage-learning-center',
        component: ManageLearningCenterComponent,
      },
    ]
  },
  {
    path: '**',
    pathMatch: 'full',
    component: PageNotFoundComponent, // ไว้ล่างสุดเสมอ
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { anchorScrolling: 'enabled', initialNavigation: 'enabled' })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
